<template>
  <div>
    <v-btn @click="open()" text icon class="hidden-md-and-up">
      <v-icon color="error"> mdi-cancel </v-icon>
    </v-btn>
    <v-btn @click="open()" class="error hidden-md-and-down" small rounded>
      <v-icon> mdi-cancel </v-icon> Cancel
    </v-btn>
    <v-navigation-drawer
      app
      temporary
      right
      disable-resize-watcher
      width="650px"
      v-model="show"
      class="actionDrawer"
    >
      <v-row class="mx-4 mt-4" justify="center" align="center">
        <v-col cols="2">
          <v-btn @click="clearOperation()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="8" class="text-center">
          <v-img
            :src="this.$store.state.agency.agencyLogo"
            width="280px"
            class="mx-auto"
          />
        </v-col>
        <v-col cols="2"> </v-col>
      </v-row>
      <v-row class="mx-4 my-4">
        <v-col v-if="alert" cols="12">
          <generalAlert
            :alert="alert"
            :alertType="alertType"
            :message="successResponse"
          />
        </v-col>
        <v-col cols="12">
          <h3>Cancel Subscription</h3>
          <p>
            This is the section where you can cancel your subscription, and all
            we need from you is to provide a reason for the cancellation.
          </p>
          <p >
            Please note if you cancel your subscription you will not be able to reactivate it, 
            if you would prefer to suspend it and reactivate it later you can in the pause susbscription rather.
          </p>
          <p class="mb-0">You can find Paused subscription if you close this and click on the <v-icon>mdi-pause-circle</v-icon> button.</p>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-card flat>
            <v-form ref="form" v-model="valid">
              <v-card-text>
                <v-textarea
                  :rules="requiredRules"
                  v-model="reason"
                  label="Reason"
                  auto-grow
                  outlined
                  rows="1"
                  row-height="15"
                ></v-textarea>
                <v-btn
                  small
                  :disabled="!valid"
                  rounded
                  class="primary"
                  @click="cancellPaypalSubcription()"
                >
                  Submit
                </v-btn>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="120"
          ><p class="mb-0 overlaytext">Please Wait...</p></v-progress-circular
        >
      </v-overlay>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../../firebaseConfig";
import generalAlert from "../alerts/generalAlert.vue";

export default {
  props: ["subscription", "successAlert"],
  components: {
    generalAlert,
  },
  data: () => ({
    show: false,
    valid: false,
    overlay: false,
    reason: "",
    requiredRules: [(v) => !!v || "This Field Is Required"],
    alert: false,
    alertType: "",
    successResponse: "",
  }),
  methods: {
    //open New Subscribtion Drawer and display over Layer
    open() {
      this.show = !this.show;
    },
    clearOperation() {
      this.reason = "";
      this.show = false;
    },
    validate() {
      this.$refs.form.validate();
    },
    cancellPaypalSubcription(){
      this.overlay = true;
      try{
        const functions = getFunctions(firebaseApp, "europe-west2");
        const paypalCancelSubscriptionImmediately = httpsCallable(functions, "paypalCancelSubscriptionImmediately");

        paypalCancelSubscriptionImmediately({
          paypalSubscriptionId:this.subscription.paypalSubscriptionId,
          subscriptionUid: this.subscription.uid,
          cancelReason: this.reason,
        }).then((result) => {
            console.log('result cancelledPayPalSub', result)
            console.log('result cancelledFirebaseSub', result)
            this.overlay = false;
            this.alertType = "success";
            this.successResponse = "Subscription Successfully Cancelled!";
            this.$emit("successAlert", this.successResponse, this.alertType);
            this.$refs.form.reset();
            this.show = false;
        });
      }catch(error){
            console.log(error)
            this.overlay = false;
            this.alert = true;
            this.alertType = "error";
            this.successResponse = `Subscription Cancellation Unsuccessful! Subscription may not exist or system is unavalible at the moment please try again later. Else contact support.`;
            setTimeout(() => {
              this.alert = false;
            }, 8000);
      }
    },
    // cancellSubscriptions() {
    //   try {
    //     const functions = getFunctions(firebaseApp, "europe-west2");
    //     const CancelSubscription = httpsCallable(
    //       functions,
    //       "CancelSubscription"
    //     );
    //     CancelSubscription({
    //       subscriptionUid: this.subscription.uid,
    //       cancelReason: this.reason,
    //     })
    //       .then((result) => {
    //         this.overlay = false;
    //         this.alertType = "success";
    //         this.successResponse = "Subscription Successfully Cancelled!";
    //         this.$emit("successAlert", this.successResponse, this.alertType);
    //         this.$refs.form.reset();
    //         this.show = false;
    //       })
    //       .catch((err) => {
    //         this.overlay = false;
    //         this.alert = true;
    //         this.alertType = "error";
    //         this.successResponse = `Subscription Cancellation Unsuccessful! Subscription may not exist or system is unavalible at the moment please try again later. Else contact support.`;
    //         setTimeout(() => {
    //           this.alert = false;
    //         }, 8000);
    //       });
    //   } catch (err) {
    //     this.overlay = false;
    //     console.log("err cancellSubscriptions", err);
    //   }
    // },
  },
};
</script>
